let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f9fPO")).then(() => parcelRequire('bWvgQ'));